import { Card } from '@mui/material';
import { ButtonForm } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import DotsLoader from 'Components/DotsLoader';

export const CardConfigInstall = ({ id, mutationScheduleInstallScan, mutationCheckInstall }) => {
  const checkInstall = async () => {
    await mutationScheduleInstallScan.mutateAsync(id);
    mutationCheckInstall.mutate(id);
  };
  return (
    <Row>
      <Column xs={12}>
        <Card
          sx={{
            padding: '16px',
            marginBlockStart: '16px',
            boxShadow: 'none',
            border: '1px solid #ccc',
          }}
        >
          <Row className="mb-3">
            <Column>
              <span style={{ fontSize: '20px', color: '#4b90fe' }}>Configuração da Instalação</span>
            </Column>
          </Row>
          <Row>
            <Column flex justifyContent="end">
              <ButtonForm
                variant="button"
                label={mutationCheckInstall.isLoading ? <DotsLoader /> : 'Verificar instalação'}
                onClick={() => {
                  checkInstall();
                }}
                disabled={mutationCheckInstall.isLoading}
              />
            </Column>
          </Row>
        </Card>
      </Column>
    </Row>
  );
};
